import { PageHeader, LoadingState, DataTable } from '../components/AdminPageUI';
import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Paper, Chip, IconButton, Alert } from '@mui/material';
import { Download } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import api from '../utils/Api';
import TransactionPDF from '../components/TransactionPDF';

const SchoolBillingPage = () => {
    const [transactions, setTransactions] = useState([]);
    const [schoolInfoProfile, setSchoolInfoProfile] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const school = JSON.parse(localStorage.getItem('user'))?.school || {};

    useEffect(() => {
        fetchTransactions();
    }, []);

    const fetchTransactions = async () => {
        try {
            setLoading(true);
            const res = await api.get('/school/my-transactions');
            setTransactions(res.data.transactions || []);
            setSchoolInfoProfile(res.data.schoolInfo || {});
        } catch (err) {
            console.error("Failed to fetch transactions:", err);
            setError("Failed to load your bills and receipts");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <LoadingState />
        );
    }

    if (error) {
        return <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>;
    }

    return (
        <Box>
            <PageHeader title="Platform Billing & Receipts" description="View all your invoices and payment receipts from CoreVista Technologies." />
            

            <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent>
                    <DataTable component={Paper} elevation={0}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>Download</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {transactions.map(t => (
                                    <TableRow key={t._id} hover>
                                        <TableCell>{new Date(t.createdAt).toLocaleDateString()}</TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={t.type.toUpperCase()}
                                                color={t.type === 'payment' ? 'success' : 'primary'}
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell>{t.description}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                            ₵ {Number(t.amount).toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={t.status.toUpperCase()}
                                                color={t.status === 'paid' ? 'success' : t.status === 'pending' ? 'warning' : 'error'}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <PDFDownloadLink
                                                document={<TransactionPDF transaction={t} school={school} schoolInfoProfile={schoolInfoProfile} />}
                                                fileName={`${t.type}_${school.name?.replace(/\s+/g, '') || 'School'}_${t._id.slice(-4)}.pdf`}
                                            >
                                                {({ loading }) => (
                                                    <IconButton size="small" color="primary" disabled={loading} title="Download PDF">
                                                        <Download fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </PDFDownloadLink>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {transactions.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                            <Typography color="text.secondary">No bills or receipts found.</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </DataTable>
                </CardContent>
            </Card>
        </Box>
    );
};

export default SchoolBillingPage;
